import { doc, onSnapshot } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { usersRef } from "../firebase";

const UserContext = React.createContext(null);

const UserProvider = ({ children }) => {
  //const auth = useContext(AuthContext);
  let auth = null;
  const [user, setUser] = useState({});

  useEffect(() => {
    if (auth?.user?.uid) {
      let userRef = doc(usersRef, auth.user.uid);
      const unsubFromUserChanges = onSnapshot(userRef, (snapshot) => {
        let incomingRequests = [];
        if (snapshot.data()?.incomingReqs) {
          for (let req in snapshot.data().incomingReqs) {
            incomingRequests.push(snapshot.data().incomingReqs[req]);
          }
        }
        setUser({ ...snapshot.data(), incomingReqs: [...incomingRequests] });
      });

      return () => {
        unsubFromUserChanges();
      };
    }
  }, [auth]);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export { UserContext, UserProvider };
